import actions from './actions';

const initState = {
  isSearching: false,
  isCreating: false,
  isUpdating: false,
  isDeleting: false,
};

export default function reducer(state = initState, action) {
  switch (action.type) {
    case actions.GET_COUNTIES: {
      return {
        ...state,
        isSearching: true,
      };
    }
    case actions.GET_COUNTIES_ENDED: {
      return {
        ...state,
        isSearching: false,
      };
    }
    default:
      return state;
  }
}
